function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 303.32,
    cy: 343.39,
    r: 125.25,
    fill: "none",
    stroke: props.color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.92,
    y: 136.02,
    width: 554.15,
    height: 409.92,
    rx: 27.45,
    ry: 27.45,
    fill: "none",
    stroke: props.color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.21 54.06h149.62c10.31 0 18.67 8.37 18.67 18.67v63.29H90.54V72.73c0-10.31 8.37-18.67 18.67-18.67z",
    fill: "none",
    stroke: props.color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24.65
  }));
}
export default SvgPhoto;